import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  // form
  targetId: Constants.RegisterHash,
  values: {},

  // model
  serviceModel: [],
  noticeTypeMstModel: [],
  deliveryTypeMstModel: [],
  relationalNoticeTypeModel: [],
  serviceAttributeModel: [],

  // サービス運用者用
  serviceDetailModel: {},

  // validate
  // モジュールのバリデート結果
  validate: false,

  // ロケーションのニックネーム
  locationNickname: null,
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        case 'inpDeliveryPlanType':
          return Utility.getConstantsLabel(['Notice', 'DeliveryPlanType'], value)
        case 'inpImmediateDeliveryEndDate':
        case 'inpReservedDeliveryStartDate':
        case 'inpReservedDeliveryEndDate':
        case 'inpRepeatedDeliveryStartDate':
        case 'inpRepeatedDeliveryEndDate':
          return Utility.dateFormat(value, 'YYYY/MM/DD')
        case 'inpDeliveryPattern':
          return Utility.getConstantsLabel(['Notice', 'DeliveryPattern'], value)
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  },

  noticeType: state => state.noticeTypeMstModel.find(item => item.noticeTypeMstUuid === state.values.inpNoticeType).noticeType,

  deliveryType: state => state.deliveryTypeMstModel.find(item => item.deliveryTypeMstUuid === state.values.inpDeliveryType).deliveryType
}

const actions = {
  /**
   * 初期読出し
   */
  loadModel ({commit}, {targetId, serviceParams, serviceDetailParams}) {
    commit('setTargetId', targetId)

    return new Promise((resolve, reject) => {
      const isAdmin = this.getters['auth/isAdmin']

      const types = ['noticeTypeMst']
      const methods = ['v1NoticeTypeMstListGet']
      const parameters = [{}]

      // システム管理者の場合
      if (isAdmin) {
        types.push('service')
        methods.push('v1ServiceListGet')
        parameters.push(serviceParams)

      // サービス運用者の場合
      } else {
        types.push('service')
        methods.push('v1ServiceDetailGet')
        parameters.push(serviceDetailParams)
      }

      // データを読出し
      ApiManager.request(types, methods, parameters)
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('inited')
            commit('setNoticeTypeMstModel', res[0].data.noticeTypeMsts)
            console.log('noticeTypeMstModel', state.noticeTypeMstModel)
            if (isAdmin) {
              commit('setServiceModel', res[1].data.serviceInfo)
              console.log('serviceModel', state.serviceModel)
            } else {
              commit('setServiceDetailModel', res[1].data.serviceBasicInfo)
              console.log('serviceDetailModel', state.serviceDetailModel)

              const serviceUuid = this.getters['auth/userServiceUuid']
              commit('setInputValue', {
                key: 'inpService',
                value: serviceUuid
              })
            }
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * サービス配信タイプリストを取得
   * 配信タイプに紐づくお知らせタイプを取得
   */
  loadServiceDeliveryTypeModel ({commit}, {serviceDeliveryTypeParams, deliveryTypeMstParams, serviceAttributeParams}) {
    return new Promise((resolve, reject) => {
      // データを読出し
      ApiManager.request(
        [
          // 'deliveryTypeMst',
          'serviceDeliveryType',
          'deliveryTypeMst',
          'serviceAttributeType'
        ],
        [
          // 'v1DeliveryTypeMstListGet',
          'v1ServiceDeliveryTypeListGet',
          'v1DeliveryTypeMstRelationalNoticeTypeMstListGet',
          'v1ServiceAttributeTypeListGet'
        ],
        [
          serviceDeliveryTypeParams,
          deliveryTypeMstParams,
          serviceAttributeParams
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            // commit('setDeliveryTypeMstModel', res[0].data.deliveryTypeMsts)
            commit('setDeliveryTypeMstModel', res[0].data.serviceDeliveryTypes)
            commit('setRelationalNoticeTypeModel', res[1].data.deliveryType_noticeType_rel)
            commit('setServiceAttributeModel', res[2].data.serviceAttributeTypes)
            console.log('deliveryTypeMstModel', state.deliveryTypeMstModel)
            console.log('relationalNoticeTypeModel', state.relationalNoticeTypeModel)
            console.log('serviceAttributeModel', state.serviceAttributeModel)
            resolve(res[0].data)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 配信タイプに紐づくお知らせタイプを取得
   */
  loadRelationalNoticeTypeModel ({commit}, {deliveryTypeMstParams}) {
    return new Promise((resolve, reject) => {
      // データを読出し
      ApiManager.request(
        ['deliveryTypeMst'],
        ['v1DeliveryTypeMstRelationalNoticeTypeMstListGet'],
        [deliveryTypeMstParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setRelationalNoticeTypeModel', res[0].data.deliveryType_noticeType_rel)
            console.log('loadRelationalNoticeTypeModel', state.relationalNoticeTypeModel)
            resolve(res[0].data)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state) {
    // 配信情報
    Vue.set(state.values, 'inpService', '')
    Vue.set(state.values, 'inpDeliveryType', '')
    Vue.set(state.values, 'inpNoticeType', '')
    Vue.set(state.values, 'inpTarget', '')
    Vue.set(state.values, 'inpAttribute', [])
    Vue.set(state.values, 'inpLocation', '')

    // jsonb
    Vue.set(state.values, 'inpDeliveryContents', null)
    
    // お知らせ詳細
    Vue.set(state.values, 'inpAuthor', null)
    Vue.set(state.values, 'inpDeliveryPlanType', 1)
    // 即時配信
    Vue.set(state.values, 'inpImmediateDeliveryEndDate', null)
    Vue.set(state.values, 'inpImmediateDeliveryEndHours', '')
    Vue.set(state.values, 'inpImmediateDeliveryEndMinutes', '')
    // 予約配信
    Vue.set(state.values, 'inpReservedDeliveryStartDate', null)
    Vue.set(state.values, 'inpReservedDeliveryStartHours', '')
    Vue.set(state.values, 'inpReservedDeliveryStartMinutes', '')
    Vue.set(state.values, 'inpReservedDeliveryEndDate', null)
    Vue.set(state.values, 'inpReservedDeliveryEndHours', '')
    Vue.set(state.values, 'inpReservedDeliveryEndMinutes', '')
    // 繰り返し配信
    Vue.set(state.values, 'inpDeliveryPattern', [])
    Vue.set(state.values, 'inpRepeatedDeliveryStartDate', null)
    Vue.set(state.values, 'inpRepeatedDeliveryStartHours', '')
    Vue.set(state.values, 'inpRepeatedDeliveryStartMinutes', '')
    Vue.set(state.values, 'inpRepeatedDeliveryEndDate', null)
    // Vue.set(state.values, 'inpRepeatedDeliveryEndHours', '')
    // Vue.set(state.values, 'inpRepeatedDeliveryEndMinutes', '')

    // jsonb
    Vue.set(state.values, 'inpDeviceSerial', null)
  },

  // model
  setServiceModel (state, data) {
    Vue.set(state, 'serviceModel', data)
  },
  setNoticeTypeMstModel (state, data) {
    Vue.set(state, 'noticeTypeMstModel', data)
  },
  setDeliveryTypeMstModel (state, data) {
    Vue.set(state, 'deliveryTypeMstModel', data)
  },
  setRelationalNoticeTypeModel (state, data) {
    Vue.set(state, 'relationalNoticeTypeModel', data)
  },
  setServiceAttributeModel (state, data) {
    Vue.set(state, 'serviceAttributeModel', data)
  },
  setServiceDetailModel (state, data) {
    Vue.set(state, 'serviceDetailModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  setLocationNickname (state, value) {
    Vue.set(state, 'locationNickname', value)
  },

  // validate
  setValidate (state, flag) {
    state.validate = flag
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
    state.validate = false
    state.locationNickname = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
